import { useState, useCallback } from "react";

export function useSelection() {
  const [selected, setSelected] = useState([]);

  const toggle = useCallback((id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  }, []);

  const toggleAll = useCallback((ids) => {
    setSelected((prev) => {
      const allSelected = ids.every((id) => prev.includes(id));
      if (allSelected) {
        return prev.filter((id) => !ids.includes(id));
      }
      return [...new Set([...prev, ...ids])];
    });
  }, []);

  const clear = useCallback(() => setSelected([]), []);

  return { selected, toggle, toggleAll, clear };
}
